<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar flat>
                    <v-toolbar-title>
                        {{ game.title }}
                    </v-toolbar-title>

                    <v-spacer/>

                    <game-menu :game="game"/>
                </v-toolbar>

                <v-card flat tile min-height="500px">
                    <v-card-text>
                        <v-row>
                            <template v-for="(cardBack, cardBackIndex) in filteredCardBacks">
                                <v-col :key="'discard' + cardBackIndex"
                                       cols="12"
                                       sm="6"
                                       md="4"
                                       xl="3">
                                    <card :card-back="cardBack"
                                          :game="game"
                                          :discarded="true"
                                          @givenTo="cardGivenTo"
                                          @detachedCard="detachedCard"/>
                                </v-col>
                            </template>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import GameService from "../services/GameService";
  import Card from "./Card";
  import CardService from "../services/CardService";
  import GameMenu from "./GameMenu";

  export default {
    components: {
      GameMenu,
      Card
    },

    data: () => ({
      cardTypes: [],
      cardTypeSelection: []
    }),

    created() {
      this.viewGame();
      this.indexCardTypes();
    },

    computed: {
      game() {
        return this.$store.getters.game;
      },

      filteredCardBacks() {
        if (this.cardTypeSelection.length <= 0) {
          return this.game.discarded_cards;
        }

        return this.game.discarded_cards.filter(cardBack => this.cardTypeSelection.includes(cardBack.cardFront.cardType.title) || cardBack.cardFront.reckoning && this.cardTypeSelection.includes("Reckoning"));
      }
    },

    methods: {
      indexCardTypes() {
        CardService.indexTypes()
          .then(response => {
            this.cardTypes = response.data.data;
          });
      },

      viewGame() {
        GameService.view(this.$route.params.gameId)
          .then(response => {
            this.$store.dispatch("setGameId", response.data.data.id);
            this.$store.dispatch("setGame", response.data.data);
          })
          .catch(() => {
            this.$router.push({name: "home"});
          });
      },

      cardGivenTo(investigatorIndex) {
        this.$router.push({name: 'game', params: {gameId: this.game.id, tab: investigatorIndex}});
      },

      detachedCard() {
        this.viewGame();
      }
    }
  };
</script>
